import { Component } from '@angular/core';
import { ApplicationsState } from '../../modules/applications/applications.state';
import { selectUrlParams } from '../../modules/url-params/url-params.selector';
import { Store } from '@ngrx/store';
import { selectConfig } from '../../modules/config/config.selector';
import { ContainerComponent } from '../../modules/shared/components/container-component/unsubscribe.component';
import { GeorgeState } from '../../modules/url-params/model/george-state.model';
import { SourceAppService } from '../../core/services/source-app.service';
import { UrlParams } from '../../modules/url-params/model/url-params.model';
import { HttpParams } from '@angular/common/http';
import { LoggerService } from '../../core/services/logger.service';

import 'rxjs/add/operator/takeUntil';
import 'rxjs/add/operator/filter';

@Component({
    selector: 'ssf-mep-handover',
    template: require('./mep-handover.component.html'),
    styles: [require('./mep-handover.component.scss')]
})
/**
 * Component to handover to George.
 *
 * See Specifikace služby handover - https://docs.google.com/document/d/1aoIbpVicHze0L-uoK1sfo2cOjLObYDKI4r4aDasslGU
 */
export class MepHandoverComponent extends ContainerComponent {

    public mepHandoverUrl: string;
    public urlParams: UrlParams;
    public state: GeorgeState;

    public oidc = false;
    public showHandover = false;
    public i18n = 'APP.HANDOVER.';

    constructor(
        private store: Store<ApplicationsState>,
        private sourceService: SourceAppService,
        private logger: LoggerService,
    ) {
        super();

        this.store.select(selectConfig).subscribe(config => {
            this.mepHandoverUrl = config ? config.mepHandoverUrl : null;
        });

        this.store.select(selectUrlParams)
            .takeUntil(this.ngUnsubscribe)
            .filter((urlParams: UrlParams) => !!urlParams)
            .subscribe(urlParams => {
                if (this.sourceService.isFromGeorge()) {
                    this.showHandover = true;
                    this.urlParams = urlParams;
                    this.state = urlParams.state;
                    this.oidc = urlParams.oidc;
                }
            });
    }

    handoverToGeorgeOidc() {
        const params: HttpParams = new HttpParams()
            .set('state', this.state.returnState)
            .set('language_id', this.urlParams.lang);
        const url = this.state.redirectUri + '?' + params.toString();
        this.logger.log('Handover url: ' + url);
        window.location.assign(url);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/components/mep-handover/mep-handover.component.ts